import { useEffect, useRef, useState } from "react";
import Joyride, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import "./TutorialStyles.scss";

import { update_tutorial_progress } from "../../network/communication";

function QuizTutorial(props) {
  const stepIndex = props.stepIndex;
  const setStepIndex = props.setStepIndex;

  const viewingResults = props.viewingResults;

  const isOnMainViewingResultsPage = props.isOnMainViewingResultsPage;
  const setIsOnMainViewingResultsPage = props.setIsOnMainViewingResultsPage;

  const tutorialPhase = props.phase;
  const setTutorialPhase = props.setPhase;

  const REVIEWING_RESULTS_PHASE = 1;

  const tutorialPhaseRef = useRef(tutorialPhase);
  const stepIndexRef = useRef(stepIndex);

  const phase0Step = [
    {
      target: "body",
      title: "Welcome to your Quiz!",
      placement: "center",
      content: "You're about to take a practice Quiz on these terms.",
    },
    {
      target: ".time-left",
      title: "This is your timer.",
      placement: "bottom",
      content: "This is how much time you have to complete this Quiz.",
    },
    {
      target: "body",
      title: "Quizzes will automatically save",
      placement: "center",
      content:
        "Quizzes on Quizzy will automatically save your progress, so you can leave and come back as much as you'd like. Make sure you don't cross the time limit though!",
    },
    {
      target: "body",
      title: "Good luck!",
      placement: "center",
      content:
        "Since this is your first practice Quiz, don't worry if you don't know all the terms yet. It's just practice. Good luck!",
    },
  ];

  // Submitted Quiz
  const phase1Step = [
    {
      target: ".review-btn",
      title: "Review your missed terms",
      placement: "left",
      content: "Click on Review to review your questions.",
      disableBeacon: true,
    },
  ];

  const phase2Step = [
    {
      target: "body",
      title: "Results Information",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/greendefinition.png"
            alt="correct definition"
            style={{ width: "100%" }}
          ></img>
          <p>If a definition is shown in green, it means you got it correct.</p>
        </>
      ),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "body",
      title: "Results Information",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/reddef.png"
            alt="incorrect definition"
            style={{ width: "100%" }}
          ></img>
          <p>
            If a definition is shown in red, it means you got it wrong. The
            correct definition will be shown in green.
          </p>
        </>
      ),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "body",
      title: "Results Information",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/overrideanswer.png"
            alt="incorrect definition"
            style={{ width: "100%" }}
          ></img>
          <p>
            If your short answer was graded incorrectly, you can override it.
          </p>
        </>
      ),
      placement: "center",
      disableBeacon: true,
    },
    {
      target: "body",
      title: "Results Information",
      content: (
        <>
          <img
            src="https://quizzynow.com/uploads/whenyouredone.png"
            alt="Done reviewing"
            style={{ width: "100%" }}
          ></img>
          <p>
            When you're done reviewing, click on the "Results" button to go
            back.
          </p>
        </>
      ),
      placement: "center",
      disableBeacon: true,
    },
  ];

  const handleJoyrideCallback = (data) => {
    const { action, index, status, type } = data;
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      if (tutorialPhase === REVIEWING_RESULTS_PHASE) {
        props.setIsOnMainViewingResultsPage(false);
      }
      console.log("TutorialPhase");
      console.log(tutorialPhase);
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if (tutorialPhase === REVIEWING_RESULTS_PHASE) {
        props.setIsOnMainViewingResultsPage(false);
      }
      console.log("TutorialPhase");
      console.log(tutorialPhase);
      setStepIndex(0);
      setTutorialPhase(tutorialPhase + 1);
    }
  };

  useEffect(() => {
    tutorialPhaseRef.current = tutorialPhase;
    stepIndexRef.current = stepIndex;
    update_tutorial_progress(
      "quiz",
      tutorialPhaseRef.current,
      stepIndexRef.current
    );
  }, [tutorialPhase, stepIndex]);

  return (
    <>
      {tutorialPhase === 0 && (
        <Joyride
          steps={phase0Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          callback={handleJoyrideCallback}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
      {tutorialPhase === 1 && viewingResults && (
        <Joyride
          steps={phase1Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          callback={handleJoyrideCallback}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          disableOverlay
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
      {tutorialPhase === 2 && viewingResults && (
        <Joyride
          steps={phase2Step}
          disableScrolling={true}
          hideBackButton
          stepIndex={stepIndex}
          callback={handleJoyrideCallback}
          locale={{
            next: "Continue",
            close: "Continue",
            last: "Continue",
          }}
          //showProgress
          continuous
          hideCloseButton
          styles={{
            options: {
              backgroundColor: "#ffffff",
              textColor: "#747474",
              primaryColor: "#8358E8",
              fontFamily: "Plus Jakarta Sans",
            },
          }}
        ></Joyride>
      )}
    </>
  );
}

export default QuizTutorial;
